/* DENSA — DESTEK BUTONU v3.0 (20 Ağu 2026)

   v3.0 — GİYDİRME (kurucu isteği): düğme metni "Destek" → "Bize Ulaşın"; solundaki konuşma
   balonu simgesi WhatsApp simgesiyle değiştirildi. Shopify Inbox'ın <shopify-chat> gölge
   DOM'una dışarıdan CSS ulaşamıyor ama gölge kökü AÇIK — v2.x'te olduğu gibi içine yazıyoruz.
   Giydirme idempotent (data-densa-wa bayrağı); Inbox düğmeyi yeniden çizerse gölge kökteki
   MutationObserver yeniden uygular. Inbox sınıf adlarını değiştirirse giydirme sessizce devre
   dışı kalır, düğme varsayılan hâliyle çalışmaya devam eder (hata güvenliği).
   NOT: Bu düğme Shopify Inbox sohbetini açar; WhatsApp'a YÖNLENDİRMEZ. Simge kararı kurucunundur;
   kanal bağlanırsa (Inbox > WhatsApp entegrasyonu) simge ile işlev de örtüşür.

   v2.2 — KONUM (özet): üç kusur ölçümle bulunup kapatılmıştı — ① algılama toleransı 40px +
   öğe ekranın alt yarısında ve ≥%40 genişlikte olmalı; ② sabit yükseklik yerine ÖLÇÜM
   (alt = ekran − çubuğun üstü + 16px); ③ debounce yerine KISITLAMA (throttle 200ms +
   sessizlikten 350ms sonra teyit) — sürekli animasyonlu sayfada ölçümün aç kalması kapatıldı.
   Kök neden: Inbox düğmesi temaya ait değil, kendi gölge DOM'unda ve uygulama sabit
   bottom:164px veriyor. Yükleme noktası: snippets/densa-istek.liquid (site geneli). */
(function () {
  var ALT_NORMAL = 24;
  var PAY = 16;
  var TOLERANS = 40;
  var KISIT_MS = 200;    /* en sık ölçüm aralığı */
  var SESSIZLIK_MS = 350;/* geçiş bittikten sonraki teyit ölçümü */
  var ETIKET = 'Bize Ulaşın';
  var WA_YOL = 'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z';
  var host, kok, stil, sonKural = '';

  function shopifyKromu(el) {
    var kimlik = (el.id || '') + ' ' + ((el.className || '').toString());
    return /PBar|shopify-pbar|preview-bar|admin-bar/i.test(kimlik);
  }

  function altCubugunUstu() {
    var vh = window.innerHeight, enUst = null;
    var hepsi = document.body ? document.body.querySelectorAll('*') : [];
    for (var i = 0; i < hepsi.length; i++) {
      var el = hepsi[i];
      if (el === host || el.tagName === 'SHOPIFY-CHAT') continue;
      if (shopifyKromu(el)) continue;
      if (el.tagName === 'DIALOG' && !el.open) continue;
      var s = window.getComputedStyle(el);
      if (s.position !== 'fixed' && s.position !== 'sticky') continue;
      if (s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity) === 0) continue;
      var r = el.getBoundingClientRect();
      if (r.height < 20 || r.width < window.innerWidth * 0.4) continue;
      /* transform ile aşağı kaydırılmış (gizli) çubuklar buradan elenir */
      if (r.bottom <= 0 || r.top >= vh) continue;
      if (vh - r.bottom > TOLERANS || vh - r.bottom < -8) continue;
      if (r.top < vh * 0.55) continue;
      if (enUst === null || r.top < enUst) enUst = r.top;
    }
    return enUst;
  }

  /* v3.0 — metin + simge giydirme (idempotent) */
  function giydir() {
    if (!kok) return;
    try {
      var act = kok.querySelector('.activator');
      if (!act) return;
      if (act.getAttribute('aria-label') !== ETIKET) act.setAttribute('aria-label', ETIKET);
      var lab = act.querySelector('.activator__label');
      if (lab && lab.textContent !== ETIKET) lab.textContent = ETIKET;
      var ikon = act.querySelector('.activator__icon');
      if (ikon && !ikon.querySelector('svg[data-densa-wa]')) {
        ikon.innerHTML = '<svg data-densa-wa="1" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 28 28" aria-hidden="true" focusable="false" style="fill:currentColor;stroke:none"><path d="' + WA_YOL + '"></path></svg>';
      }
    } catch (e) {}
  }

  function uygula() {
    if (!kok) return;
    giydir();
    var ust = altCubugunUstu();
    var alt = (ust === null) ? ALT_NORMAL : Math.round(window.innerHeight - ust) + PAY;
    if (alt < ALT_NORMAL) alt = ALT_NORMAL;
    var kural = '.activator-nudge{bottom:' + alt + 'px !important;}';
    if (kural === sonKural) return;
    sonKural = kural;
    if (!stil) {
      stil = document.createElement('style');
      stil.setAttribute('data-densa', 'destek-konum');
      kok.appendChild(stil);
    }
    stil.textContent = kural;
  }

  /* v2.2: KISITLAMA — debounce değil. Sayfada sürekli animasyon olsa bile ölçüm aç kalmaz. */
  var sonCalisma = 0, teyit = null;
  function tetikle() {
    var simdi = Date.now();
    if (simdi - sonCalisma > KISIT_MS) { sonCalisma = simdi; uygula(); }
    clearTimeout(teyit);
    teyit = setTimeout(function () { sonCalisma = Date.now(); uygula(); }, SESSIZLIK_MS);
  }

  function bagla() {
    if (kok) return true;
    host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return false;
    if (!host.shadowRoot.querySelector('.activator-nudge')) return false;
    kok = host.shadowRoot;
    uygula();
    window.addEventListener('resize', tetikle);
    window.addEventListener('orientationchange', tetikle);
    window.addEventListener('scroll', tetikle, { passive: true });
    try {
      new MutationObserver(tetikle)
        .observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'style'] });
    } catch (h) {}
    try {
      /* v3.0: Inbox düğmeyi yeniden çizerse giydirmeyi anında tazele (kendi yazımlarımız
         idempotent olduğu için döngü oluşmaz — değişiklik yoksa DOM'a dokunulmaz). */
      new MutationObserver(function () { giydir(); })
        .observe(kok, { childList: true, subtree: true });
    } catch (h) {}
    return true;
  }

  var deneme = 0;
  var saat = setInterval(function () {
    if (bagla() || ++deneme > 40) clearInterval(saat);
  }, 500);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bagla);
  else bagla();
})();
